var _pattern, _mask, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegendPath1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "legend-path-1-pattern",
    width: 4,
    height: 4,
    patternUnits: "userSpaceOnUse",
    stroke: "white",
    strokeLinecap: "square",
    strokeWidth: 3,
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4,
    y2: 0
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "legend-path-1-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12,
    height: 12,
    fill: "url(#legend-path-1-pattern)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12,
    fill: "currentColor",
    className: "fill-color",
    x: 2,
    mask: "url(#legend-path-1-mask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendPath1);
export default __webpack_public_path__ + "static/media/legend-path-1.f34315436dfc63d5b9981419773d27c1.svg";
export { ForwardRef as ReactComponent };